import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"
import { InsightPopupHeaderProps } from "./InsightPopupHeader"

const { WithSuspense: InsightAbout } = lazyloadHelper(
    () => import(/* webpackChunkName: "dietinsight" */ "./InsightAbout"),
)

const { WithSuspense: InsightPopupHeader } = lazyloadHelper<InsightPopupHeaderProps>(
    () => import(/* webpackChunkName: "dietinsight" */ "./InsightPopupHeader"),
)
export { InsightPopupHeader, InsightAbout }
